import { FC } from 'react';
import Imgix from 'react-imgix';
import { Box, OTitle, Flex } from '@lifechurch/react-ion';

interface GenericErrorProps {
  title?: string;
  imageUrl?: string;
  imageHeight?: number;
  imageWidth?: number;
}

const GenericError: FC<GenericErrorProps> = ({
  title = 'An Error Occurred.',
  imageUrl = '/assets/500_comp.png',
  imageHeight = 244,
  imageWidth = 224,
}) => {
  return (
    <Flex alignItems='center' justifyContent='center' height='100vh'>
      <Box mr={'56px'}>
        <Imgix
          src={`https://chop.imgix.net/${process.env.NEXT_PUBLIC_APP_ENV}${imageUrl}`}
          width={imageWidth}
          height={imageHeight}
          imgixParams={{
            auto: 'format',
          }}
          htmlAttributes={{
            'data-testid': 'errorImage',
          }}
        />
      </Box>

      <Box>
        <OTitle mb={16}>{title}</OTitle>
      </Box>
    </Flex>
  );
};

export default GenericError;
